import { ENUM_API_TYPE, ENUM_ENDPOINT } from '../enum/API';
import APICore from './api_core';

interface Network {
    get: (endPoint: string) => Promise<any>,
    post: (endPoint: ENUM_ENDPOINT, data: FormData) => Promise<any>,
    moveZendeskUrl: () => Promise<any>,
}

const api = (type: ENUM_API_TYPE): Network => {
    return new Api();
};

class Api extends APICore implements Network {
    // 젠데스크 이동
    moveZendeskUrl = async () => {
        const baseAPIUrl = 'https://api.wehago.com';
        const endPoint = '/common/cs/gotowehagohelpdesk?toUrl=/hc/ko/requests/new?ticket_form_id=900000086303&request_type=202';
        const url = `${baseAPIUrl}${endPoint}`;

        // 위하고 api를 사용하려면 token을 생성해서 헤더를 보내야 했다.
        this.setEndPoint(endPoint);
        const headers = await this.getHeaders();

        return fetch(url, {
            method: 'POST',
            headers,
        })
            .then((response) => {
                response.json().then((res: any) => {
                    if (res.resultData !== '' && typeof (res.resultData) === 'string') {
                        window.open(res.resultData);
                    } else {
                        window.open('https://wehagohelp.zendesk.com');
                    }
                })
            }).catch((err) => {
                window.open('https://wehagohelp.zendesk.com');
                console.log(err);
            });
    };

    public post = async (endPoint: ENUM_ENDPOINT, data: FormData): Promise<any> => {
        this.setEndPoint(endPoint);
        const formData = data;
        const headers = await this.getHeaders();
        return fetch(this.getUrl(), {
            method: 'POST',
            headers,
            body: formData,
        });
    };

    public get = async (endPoint: string): Promise<any> => {
        this.setEndPoint(endPoint);
        const headers = await this.getHeaders();
        return fetch(this.getUrl(), {
            method: 'GET',
            headers,
        });
    };
}


export default api;
